import { Input } from "../../../components/ui";
import type { EmpresaConfiguracion, EmpresaConfiguracionUpdate } from "../api";
import { SaveBar, nullIfEmpty, useConfigForm } from "./_shared";

interface Form {
  horario_atencion: string;
  correo_reclamos: string;
}

const extractor = (cfg: EmpresaConfiguracion): Form => ({
  horario_atencion: cfg.horario_atencion ?? "",
  correo_reclamos: cfg.correo_reclamos ?? "",
});

const differ = (
  f: Form,
  cfg: EmpresaConfiguracion,
): EmpresaConfiguracionUpdate => {
  const out: EmpresaConfiguracionUpdate = {};
  if (nullIfEmpty(f.horario_atencion) !== cfg.horario_atencion)
    out.horario_atencion = nullIfEmpty(f.horario_atencion);
  if (nullIfEmpty(f.correo_reclamos) !== cfg.correo_reclamos)
    out.correo_reclamos = nullIfEmpty(f.correo_reclamos);
  return out;
};

export function AtencionTab({
  cfg,
}: {
  cfg: EmpresaConfiguracion;
}): JSX.Element {
  const { form, setForm, haycambios, pending, reset, save } = useConfigForm(
    cfg,
    extractor,
    differ,
  );

  return (
    <div className="space-y-4 max-w-2xl">
      <p className="text-sm text-neutral-600">
        Información de atención al usuario que exige la Ley 20.998 (cumplimiento
        SISS). El horario y correo de reclamos se publican en boleta y portal.
      </p>

      <div className="space-y-4">
        <Input
          label="Horario de atención"
          type="text"
          value={form.horario_atencion}
          onChange={(e) =>
            setForm({ ...form, horario_atencion: e.target.value })
          }
          placeholder="Lun a Vie 09:00–13:00 / 15:00–18:00"
        />
        <Input
          label="Correo para reclamos"
          hint="se imprime en boleta como contacto SISS"
          type="email"
          value={form.correo_reclamos}
          onChange={(e) =>
            setForm({ ...form, correo_reclamos: e.target.value })
          }
          placeholder="reclamos@comite.cl"
        />
      </div>

      <SaveBar
        haycambios={haycambios}
        pending={pending}
        reset={reset}
        save={save}
      />
    </div>
  );
}
